import { render, staticRenderFns } from "./PropertyMap.vue?vue&type=template&id=16b766ec"
import script from "./PropertyMap.vue?vue&type=script&lang=ts"
export * from "./PropertyMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports